import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './Layout.html';
import moment from 'moment';
import UserService from '../../shared/userService/UserService';
import UserModel from '../../shared/userService/Model/UserModel';
import TokenService from '../../Services/TokenService';
import { Toaster } from '../../Services/toast';
import LoginService from '../Login/LoginService';
import UserRoleService from '../../shared/userService/UserRoleService';
import PermissionManagementService from '../UserManagement/PermissionManagement/PermissionManagementService';
import { KEY_TO_SCREEN } from '../UserManagement/PermissionManagement/PermissionsKeys';
import { RequestsOptionsModel } from '../Dashboard/RequestsOptionsModel ';
import DashboardService from '../Dashboard/DashboardService';
import Dashboard from '../Dashboard/Dashboard';

@WithRender
@Component({
    diProvide: [
        DashboardService,
        UserService,
        LoginService,
        UserRoleService,
        PermissionManagementService,
    ],
})
export default class Layout extends Vue {
    @Inject(UserService) public userService!: UserService;
    @Inject(DashboardService) public dashboardService!: DashboardService;
    @Inject(TokenService) public tokenService!: TokenService;
    @Inject(LoginService) public logInService!: LoginService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Inject(PermissionManagementService) public permissionManagementService!: PermissionManagementService;
    public userName: string = '';
    public password: string = '';
    public isDropdownShow: boolean = false;
    public isReportDropdownShow: boolean = false;
    public isShortcodeConnectingShow: boolean = false;
    public isRolesManagement: boolean = false;
    public isSuggestionsAndFeedback: boolean = false;
    public isSystemConfiguration: boolean = false;
    public isFinance: boolean = false;
    public layoutSup: boolean = false;
    public logOutDialog: boolean = false;
    public loginDialog: boolean = false;
    public showPassword: boolean = false;
    public otpForm: boolean = false;
    public logInForm: boolean = true;
    public collapsed: boolean = false;
    public data: string = '';
    public otpExpiresAt: string = '';
    public otp: string = '';
    public userRole: any;
    public countDown: number = 0;
    public themeCompany: any = 'Default';
    public logoLayoutSrc: any = 'JabberLogo';
    public errorUserCertificate: boolean = false;
    public requestsOptions: RequestsOptionsModel = {} as RequestsOptionsModel;

    public user: UserModel = {
        userId: '',
        username: '',
        details: {
            Email: '',
            MobilePhone: '',
            Operator: '',
            Provider: '',
            OperatorId: '',
            TenantId: '',
            ProviderId: '',
            Role: '',
            ChangePasswordRequired: '',
        },
    };

    private get isSenderTemplateEnabled(): boolean {
        return !!(window.$config && window.$config.EnableSenderTemplate === true);
    }

    public get menuForCurrentRole() {
        const role = this.GetUserRole;

        // Super Admin
        if (role === 9) {
            return [
                {
                    key: 'SenderRequestDashboard',
                    text: this.$t('shared.dashboard'),
                    isDropdown: true,
                    route: '/Dashboard',
                    show: true,
                    children: [
                        { key: 'SenderComplaintList', text: this.$t('shared.senderComplaintsList'), route: '/SenderComplaints', show: true },
                        { key: 'SenderConnectivity', text: this.$t('shared.senderConnectivity'), route: '/SenderConectivitySupport', show: true },
                        {
                            key: 'UpdateRequests',
                            text: this.$t('shared.updateDataRequests'),
                            route: '/UpdateRequests',
                            show: !!(this.requestsOptions && this.requestsOptions.isUpdateRequstDataEnabled)
                        }
                    ].filter(child => child.show)
                },
                { key: 'ContractRequestDashboard', text: this.$t('shared.connectingRequestDashboard'), route: '/ConnectingRequestDashboard', show: true },
                { key: 'MessageTemplateDashboard', text: this.$t('shared.MessageTemplateDashboard'), route: '/MessageTemplateDashboard', show: this.isSenderTemplateEnabled },
                {
                    key: 'RolesManagement', text: this.$t('shared.rolesManagement'), isDropdown: true, show: true, children: [
                        { key: 'Providers', text: this.$t('shared.providers'), route: '/Providers', show: true },
                        { key: 'UserManagement', text: this.$t('shared.userManagement'), route: '/UserManagement', show: true }
                    ]
                },
                {
                    key: 'SystemConfig', text: this.$t('shared.systemConfiguration'), isDropdown: true, show: true, children: [
                        { key: 'Scams', text: this.$t('shared.ScamManagement'), route: '/Scams', show: true },
                        { key: 'AttachmentCategory', text: this.$t('shared.AttachmentCategory'), route: '/AttachmentCategory', show: true },
                        { key: 'RejectionReason', text: this.$t('shared.RejectionReason'), route: '/RejectionReason', show: true },
                        { key: 'RegulationsManagement', text: this.$t('shared.regulationsMenu'), route: '/Regulations', show: this.isSenderTemplateEnabled },
                        { key: 'CITCKeywords', text: this.$t('shared.CITCKeywords'), route: '/CITCKeywords', show: true },
                        { key: 'ShortCodeList', text: this.$t('shortPage.shortCodeList'), route: '/Shorts', show: true }
                    ]
                },
                {
                    key: 'Finance', text: this.$t('Finance'), isDropdown: true, show: true, children: [
                        { key: 'CreditLimitTransaction', text: this.$t('shared.CreditLimitTransaction'), route: '/CreditLimitTransaction', show: true },
                        { key: 'ProvidersFinance', text: this.$t('shared.providersFinance'), route: '/ProvidersFinance', show: true }

                    ]
                },
                {
                    key: 'Reports', text: this.$t('shared.Reports'), isDropdown: true, show: true, children: [
                        { key: 'ReportsOverview', text: this.$t('shared.ReportsOverview'), route: '/Report', show: true },
                        { key: 'ConnectivityActivationReport', text: this.$t('shared.connectivityActivationReport'), route: '/ConnectivityActivationReport', show: true },
                        { key: 'EmployeeStatistics', text: this.$t('shared.employeeStatistics'), route: '/EmployeeStatistics', show: true },
                        { key: 'SuggestionsAndSystemEnhancement', text: this.$t('shared.suggestionsAndSystemEnhancement'), route: '/SuggestionsAndSystemEnhancement', show: true },
                        { key: 'RatingResults', text: this.$t('shared.ratingResults'), route: '/RatingResults', show: true }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ];
        }

        // Provider Admin
        if (role === 5) {
            return [
                {
                    key: 'dashboard',
                    text: this.$t('shared.dashboard'),
                    isDropdown: true,
                    route: '/Dashboard',
                    show: true,
                    children: [
                        {
                            key: 'ExtendDurationRequests',
                            text: this.$t('shared.extendDurationRequests'),
                            route: '/ExtendDurationRequests',
                            show: !!(this.requestsOptions && this.requestsOptions.isRenewRequstEnabled)
                        },
                        {
                            key: 'UpdateRequests',
                            text: this.$t('shared.updateDataRequests'),
                            route: '/UpdateRequests',
                            show: !!(this.requestsOptions && this.requestsOptions.isUpdateRequstDataEnabled)
                        }
                    ].filter(child => child.show)
                },
                { key: 'MessageTemplateDashboard', text: this.$t('shared.MessageTemplateDashboard'), route: '/MessageTemplateDashboard', show: this.isSenderTemplateEnabled },

                { key: 'ContractRequestDashboard', text: this.$t('shared.connectingRequestDashboard'), route: '/ConnectingRequestDashboard', show: true },
                {
                    key: 'ShortCodes', text: this.$t('shared.shorts'), isDropdown: true, show: true, children: [
                        { key: 'ShortCodeList', text: this.$t('shortPage.shortCodeList'), route: '/Shorts', show: true },
                        { key: 'ShortcodeConnectingRequest', text: this.$t('bulkshortPage.shortCodeConnectivityRequest'), route: '/ShortcodeConnectingRequest', show: true }
                    ]
                },
                {
                    key: 'RolesManagement', text: this.$t('shared.rolesManagement'), isDropdown: true, show: true, children: [
                        { key: 'UserManagement', text: this.$t('shared.userManagement'), route: '/UserManagement', show: true }
                    ]
                },
                { key: 'SenderConnectivity', text: this.$t('shared.senderConnectivity'), route: '/SenderConectivitySupport', show: true },
                {
                    key: 'Finance', text: this.$t('Finance'), isDropdown: true, show: true, children: [
                        { key: 'Invoices', text: this.$t('shared.Invoices'), route: '/Invoices', show: true },
                        { key: 'BalanceInvoice', text: this.$t('shared.BalanceInvoice'), route: '/BalanceInvoice', show: true },
                        { key: 'CreditLimitTransaction', text: this.$t('shared.CreditLimitTransaction'), route: '/CreditLimitTransaction', show: true }
                    ]
                },
                {
                    key: 'SuggestionFeedback', text: this.$t('shared.suggestionsAndFeedback'), isDropdown: true, show: true, children: [
                        { key: 'SuggestionsAndSystemEnhancement', text: this.$t('shared.suggestionsAndSystemEnhancement'), route: '/AddSuggestionsAndSystemEnhancement', show: true }
                    ]
                },
                { key: 'MyProfile', text: this.$t('shared.myProfile'), route: '/Providers/EditProvider', show: true },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ];
        }

        // Provider User
        if (role === 2) {
            return [
                {
                    key: 'dashboard',
                    text: this.$t('shared.dashboard'),
                    isDropdown: true,
                    route: '/Dashboard',
                    show: true,
                    children: [
                        {
                            key: 'ExtendDurationRequests',
                            text: this.$t('shared.extendDurationRequests'),
                            route: '/ExtendDurationRequests',
                            show: !!(this.requestsOptions && this.requestsOptions.isRenewRequstEnabled)
                        },
                        {
                            key: 'UpdateRequests',
                            text: this.$t('shared.updateDataRequests'),
                            route: '/UpdateRequests',
                            show: !!(this.requestsOptions && this.requestsOptions.isUpdateRequstDataEnabled)
                        }
                    ].filter(child => child.show)
                },
                { key: 'MessageTemplateDashboard', text: this.$t('shared.MessageTemplateDashboard'), route: '/MessageTemplateDashboard', show: this.isSenderTemplateEnabled },

                { key: 'ContractRequestDashboard', text: this.$t('shared.connectingRequestDashboard'), route: '/ConnectingRequestDashboard', show: true },
                {
                    key: 'ShortCodes', text: this.$t('shared.shorts'), isDropdown: true, show: true, children: [
                        { key: 'ShortCodeList', text: this.$t('shortPage.shortCodeList'), route: '/Shorts', show: true },
                        { key: 'ShortcodeConnectingRequest', text: this.$t('bulkshortPage.shortCodeConnectivityRequest'), route: '/ShortcodeConnectingRequest', show: true }
                    ]
                },
                { key: 'SenderConnectivity', text: this.$t('shared.senderConnectivity'), route: '/SenderConectivitySupport', show: true },
                {
                    key: 'Finance', text: this.$t('Finance'), isDropdown: true, show: true, children: [
                        { key: 'Invoices', text: this.$t('shared.Invoices'), route: '/Invoices', show: true },
                        { key: 'BalanceInvoice', text: this.$t('shared.BalanceInvoice'), route: '/BalanceInvoice', show: true },
                        { key: 'CreditLimitTransaction', text: this.$t('shared.CreditLimitTransaction'), route: '/CreditLimitTransaction', show: true }
                    ]
                },
                {
                    key: 'SuggestionFeedback', text: this.$t('shared.suggestionsAndFeedback'), isDropdown: true, show: true, children: [
                        { key: 'SuggestionsAndSystemEnhancement', text: this.$t('shared.suggestionsAndSystemEnhancement'), route: '/AddSuggestionsAndSystemEnhancement', show: true }
                    ]
                },
                { key: 'MyProfile', text: this.$t('shared.myProfile'), route: '/Providers/EditProvider', show: true },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ];
        }

        // Platform Admin
        if (role === 1) {
            return [
                { key: 'SenderRequestDashboard', text: this.$t('shared.dashboard'), route: '/Dashboard', show: true },
                {
                    key: 'UpdateRequests',
                    text: this.$t('shared.updateDataRequests'),
                    route: '/UpdateRequests',
                    show: !!(this.requestsOptions && this.requestsOptions.isUpdateRequstDataEnabled)
                },
                { key: 'MessageTemplateDashboard', text: this.$t('shared.MessageTemplateDashboard'), route: '/MessageTemplateDashboard', show: this.isSenderTemplateEnabled },

                { key: 'ContractRequestDashboard', text: this.$t('shared.connectingRequestDashboard'), route: '/ConnectingRequestDashboard', show: true },
                { key: 'SenderComplaints', text: this.$t('shared.senderComplaintsList'), route: '/SenderComplaints', show: true },
                {
                    key: 'RolesManagement', text: this.$t('shared.rolesManagement'), isDropdown: true, show: true, children: [
                        { key: 'Providers', text: this.$t('shared.providers'), route: '/Providers', show: true },
                        { key: 'UserManagement', text: this.$t('shared.userManagement'), route: '/UserManagement', show: true }
                    ]
                },
                {
                    key: 'SystemConfig', text: this.$t('shared.systemConfiguration'), isDropdown: true, show: true, children: [
                        { key: 'Scams', text: this.$t('shared.ScamManagement'), route: '/Scams', show: true },
                        { key: 'AttachmentCategory', text: this.$t('shared.AttachmentCategory'), route: '/AttachmentCategory', show: true },
                        { key: 'RejectionReason', text: this.$t('shared.RejectionReason'), route: '/RejectionReason', show: true },
                        { key: 'CITCKeywords', text: this.$t('shared.CITCKeywords'), route: '/CITCKeywords', show: true },
                        { key: 'RegulationsManagement', text: this.$t('shared.regulationsMenu'), route: '/Regulations', show: this.isSenderTemplateEnabled }
                    ]
                },
                {
                    key: 'Finance', text: this.$t('Finance'), isDropdown: true, show: true, children: [
                        { key: 'CreditLimitTransaction', text: this.$t('shared.CreditLimitTransaction'), route: '/CreditLimitTransaction', show: true }
                    ]
                },
                {
                    key: 'Reports', text: this.$t('shared.Reports'), isDropdown: true, show: true, children: [
                        { key: 'ReportsOverview', text: this.$t('shared.ReportsOverview'), route: '/Report', show: true },
                        { key: 'ConnectivityActivationReport', text: this.$t('shared.connectivityActivationReport'), route: '/ConnectivityActivationReport', show: true }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ];
        }


        // CITC Admin
        if (role === 3) {
            return [
                { key: 'SenderRequestDashboard', text: this.$t('shared.dashboard'), route: '/Dashboard', show: true },
                { key: 'MessageTemplateDashboard', text: this.$t('shared.MessageTemplateDashboard'), route: '/MessageTemplateDashboard', show: this.isSenderTemplateEnabled },
                { key: 'ContractRequestDashboard', text: this.$t('shared.connectingRequestDashboard'), route: '/ConnectingRequestDashboard', show: true },
                { key: 'MonitorDashboard', text: this.$t('userManagementPage.monitorDashboard'), route: '/MonitorDashboard', show: true },
                { key: 'SenderComplaints', text: this.$t('shared.senderComplaintsList'), route: '/SenderComplaints', show: true },
                {
                    key: 'RolesManagement', text: this.$t('shared.rolesManagement'), isDropdown: true, show: true, children: [
                        { key: 'UserManagement', text: this.$t('shared.userManagement'), route: '/UserManagement', show: true }
                    ]
                },
                {
                    key: 'SystemConfig', text: this.$t('shared.systemConfiguration'), isDropdown: true, show: true, children: [
                        { key: 'Scams', text: this.$t('shared.ScamManagement'), route: '/Scams', show: true },
                        { key: 'AttachmentCategory', text: this.$t('shared.AttachmentCategory'), route: '/AttachmentCategory', show: true },
                        { key: 'CITCKeywords', text: this.$t('shared.CITCKeywords'), route: '/CITCKeywords', show: true },
                        { key: 'RegulationsManagement', text: this.$t('shared.regulationsMenu'), route: '/Regulations', show: this.isSenderTemplateEnabled }
                    ]
                },
                { key: 'SenderConnectivity', text: this.$t('shared.senderConnectivity'), route: '/SenderConectivitySupport', show: true },
                {
                    key: 'SuggestionsFeedback', text: this.$t('shared.suggestionsAndFeedback'), isDropdown: true, show: true, children: [
                        { key: 'SuggestionsAndSystemEnhancement', text: this.$t('shared.suggestionsAndSystemEnhancement'), route: '/SuggestionsAndSystemEnhancement', show: true },
                        { key: 'RatingResults', text: this.$t('shared.ratingResults'), route: '/RatingResults', show: true }
                    ]
                },
                {
                    key: 'Reports', text: this.$t('shared.Reports'), isDropdown: true, show: true, children: [
                        { key: 'ReportsOverview', text: this.$t('shared.ReportsOverview'), route: '/Report', show: true },
                        { key: 'ConnectivityActivationReport', text: this.$t('shared.connectivityActivationReport'), route: '/ConnectivityActivationReport', show: true }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ];
        }


        // CITC User
        if (role === 4) {
            const base = [
                { key: 'SenderRequestDashboard', text: this.$t('shared.dashboard'), route: '/Dashboard', show: true },
                { key: 'MessageTemplateDashboard', text: this.$t('shared.MessageTemplateDashboard'), route: '/MessageTemplateDashboard', show: this.isSenderTemplateEnabled },
                { key: 'ContractRequestDashboard', text: this.$t('shared.connectingRequestDashboard'), route: '/ConnectingRequestDashboard', show: true },
                { key: 'MonitorDashboard', text: this.$t('userManagementPage.monitorDashboard'), route: '/MonitorDashboard', show: true },
                { key: 'SenderComplaints', text: this.$t('shared.senderComplaintsList'), route: '/SenderComplaints', show: true },
                {
                    key: 'RolesManagement', text: this.$t('shared.rolesManagement'), isDropdown: true, show: true, children: [
                        { key: 'UserManagement', text: this.$t('shared.userManagement'), route: '/UserManagement', show: true }
                    ]
                },
                {
                    key: 'SystemConfig', text: this.$t('shared.systemConfiguration'), isDropdown: true, show: true, children: [
                        { key: 'Scams', text: this.$t('shared.ScamManagement'), route: '/Scams', show: true },
                        { key: 'AttachmentCategory', text: this.$t('shared.AttachmentCategory'), route: '/AttachmentCategory', show: true },
                        { key: 'CITCKeywords', text: this.$t('shared.CITCKeywords'), route: '/CITCKeywords', show: true },
                        { key: 'RegulationsManagement', text: this.$t('shared.regulationsMenu'), route: '/Regulations', show: this.isSenderTemplateEnabled },
                    ]
                },
                { key: 'SenderConnectivity', text: this.$t('shared.senderConnectivity'), route: '/SenderConectivitySupport', show: true },
                {
                    key: 'SuggestionsFeedback', text: this.$t('shared.suggestionsAndFeedback'), isDropdown: true, show: true, children: [
                        { key: 'SuggestionsAndSystemEnhancement', text: this.$t('shared.suggestionsAndSystemEnhancement'), route: '/SuggestionsAndSystemEnhancement', show: true },
                        { key: 'RatingResults', text: this.$t('shared.ratingResults'), route: '/RatingResults', show: true }
                    ]
                },
                {
                    key: 'Reports', text: this.$t('shared.Reports'), isDropdown: true, show: true, children: [
                        { key: 'ReportsOverview', text: this.$t('shared.ReportsOverview'), route: '/Report', show: true },
                        { key: 'ConnectivityActivationReport', text: this.$t('shared.connectivityActivationReport'), route: '/ConnectivityActivationReport', show: true }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ];
            return this.applyPermissions(base);
        }



        // Support
        if (role === 6) {
            return [
                { key: 'SenderConnectivity', text: this.$t('shared.SenderConnectivitySupport'), route: '/SenderConectivitySupport', show: true },
                { key: 'SenderRequestSupport', text: this.$t('shared.senderRequestSupport'), route: '/SenderRequestSupport', show: true },
                { key: 'Providers', text: this.$t('shared.providers'), route: '/ProviderSupport', show: true },
                { key: 'SupportPaymentTransaction', text: this.$t('shared.SupportPaymentTransaction'), route: '/SupportPaymentTransaction', show: true },
                { key: 'PreApprovedTemplates', text: this.$t('shared.preApprovedTemplates'), route: '/PreApprovedTemplates', show: this.isSenderTemplateEnabled },
                {
                    key: 'SuggestionsFeedback', text: this.$t('shared.suggestionsAndFeedback'), isDropdown: true, show: true, children: [
                        { key: 'SuggestionsAndSystemEnhancement', text: this.$t('shared.suggestionsAndSystemEnhancement'), route: '/SuggestionsAndSystemEnhancement', show: true },
                        { key: 'RatingResults', text: this.$t('shared.ratingResults'), route: '/RatingResults', show: true }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ];
        }

        // Finance
        if (role === 8) {
            return [
                { key: 'Invoices', text: this.$t('shared.Invoices'), route: '/Invoices', show: true },
                { key: 'BalanceInvoice', text: this.$t('shared.BalanceInvoice'), route: '/BalanceInvoice', show: true },
                {
                    key: 'Finance', text: this.$t('Finance'), isDropdown: true, show: true, children: [
                        { key: 'CreditLimitTransaction', text: this.$t('shared.CreditLimitTransaction'), route: '/CreditLimitTransaction', show: true }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ];
        }

        // Monitor
        if (role === 10) {
            return [
                { key: 'MonitorDashboard', text: this.$t('userManagementPage.monitorDashboard'), route: '/MonitorDashboard', show: true }
            ];
        }

        // Managing Requests
        if (role === 15) {
            return [
                { key: 'SenderRequestDashboard', text: this.$t('shared.dashboard'), route: '/Dashboard', show: true },
                {
                    key: 'UpdateRequests',
                    text: this.$t('shared.updateDataRequests'),
                    route: '/UpdateRequests',
                    show: !!(this.requestsOptions && this.requestsOptions.isUpdateRequstDataEnabled)
                },
                { key: 'MessageTemplateDashboard', text: this.$t('shared.MessageTemplateDashboard'), route: '/MessageTemplateDashboard', show: this.isSenderTemplateEnabled },
                { key: 'ConnectingRequestDashboard', text: this.$t('shared.connectingRequestDashboard'), route: '/ConnectingRequestDashboard', show: true },
                { key: 'ReportsOverview', text: this.$t('shared.ReportsOverview'), route: '/Report', show: true },
                {
                    key: 'Finance', text: this.$t('Finance'), isDropdown: true, show: true, children: [
                        { key: 'CreditLimitTransaction', text: this.$t('shared.CreditLimitTransaction'), route: '/CreditLimitTransaction', show: true }
                    ]
                },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ];
        }

        // Fraud Management
        if (role === 16) {
            return [
                { key: 'SenderComplaints', text: this.$t('shared.senderComplaintsList'), route: '/SenderComplaints', show: true },
                { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
            ];
        }

        // Default
        return [
            { key: 'SLA', text: this.$t('shared.sla'), route: '/SLA', show: true }
        ];

    }

    public activeDropdownKey: string | null = null;
    public openDropdown(key: string) {
        this.activeDropdownKey = (this.activeDropdownKey === key) ? null : key;
    }
    public isDropdownOpen(key: string) {
        return this.activeDropdownKey === key;
    }
    public closeAllDropdowns() {
        this.activeDropdownKey = null;
    }

    public isDropdownParentActive(item: any): boolean {
        if (!item.children) return false;
        return item.children.some((child: { route: string; }) => this.$route.path === child.route);
    }




    public created() {
        if (process.env.VUE_APP_TITLE !== undefined && process.env.VUE_APP_LogoLayoutSrc !== undefined) {
            this.themeCompany = process.env.VUE_APP_TITLE.toString();
            this.logoLayoutSrc = process.env.VUE_APP_LogoLayoutSrc.toString();
        } else {
            this.themeCompany = 'Default';
            this.logoLayoutSrc = 'JabberLogo';
        }
        this.countDownTimer();
    }

    public async mounted() {
        this.user = await this.userService.getUser();
        await this.getRequestsOptions();

        await this.refreshAllowedScreens();
        this.$router.afterEach(async () => {
            await this.refreshAllowedScreens();
        });
        this.$router.afterEach(() => this.closeAllDropdowns());
    }
    public async getRequestsOptions() {
        try {
            const response = await this.dashboardService.getRequestsOptions();
            if (response && response.result) {
                this.requestsOptions.isRenewRequstEnabled = response.result.isRenewRequstEnabled;
                this.requestsOptions.isUpdateRequstDataEnabled = response.result.isUpdateRequstDataEnabled;
                this.requestsOptions = {
                    ...this.requestsOptions,
                    isRenewRequstEnabled: response.result.isRenewRequstEnabled,
                    isUpdateRequstDataEnabled: response.result.isUpdateRequstDataEnabled,
                };
                let stored: any = {};
                try {
                    const raw = sessionStorage.getItem('requestsOptions');
                    if (raw) {
                        stored = JSON.parse(raw) || {};
                    }
                } catch (parseError) {
                    stored = {};
                }
                sessionStorage.setItem('requestsOptions', JSON.stringify({
                    ...stored,
                    isUpdateRequstDataEnabled: response.result.isUpdateRequstDataEnabled,
                }));
            }
        } catch (error) {
            console.error("Error fetching options", error);
            this.requestsOptions.isRenewRequstEnabled = false;
            this.requestsOptions.isUpdateRequstDataEnabled = false;
            sessionStorage.setItem('requestsOptions', JSON.stringify({
                isUpdateRequstDataEnabled: false,
            }));
        }
    }
    public collapse() {
        this.collapsed = !this.collapsed;
    }

    public closeMobileMenu() {
        this.collapsed = false;
        this.closeAllDropdowns();
    }

    @Watch('$route')
    public onRouteChange() {
        this.closeMobileMenu();
    }

    public onChildInit(value: boolean) {
        this.layoutSup = value;
    }

    public get currentYear() {
        return moment().year();
    }

    public showLogOutDialog() {
        this.logOutDialog = true;
    }

    public hideLogOutDialog() {
        this.logOutDialog = false;
    }

    public async logOut() {
        await this.tokenService.setToken('');
        this.logOutDialog = false;
        this.$router.push({ name: 'Login' });
    }

    public countDownTimer() {
        const currentDate = moment().format('lll');
        if (!moment(currentDate).isAfter(localStorage.expiresIn)) {
            setTimeout(() => {
                this.countDownTimer();
                localStorage.timer -= 1;
                if (localStorage.timer === '900') {
                    Toaster.warning('15 minutes left for your login to expire', this.showLoginDialog);
                }
            }, 1000);
        } else {
            this.logOut();
        }
    }

    public showLoginDialog() {
        this.userName = '';
        this.otp = '';
        this.password = '';
        this.loginDialog = true;
    }

    public hideLoginDialog() {
        this.loginDialog = false;
        this.logInForm = true;
        this.otpForm = false;
    }

    public get GetUserRole() {
        return this.userRoleService.GetUserRole(this.user);
    }
    public get isValid(): boolean {
        return (this.userName.trim() !== '' && this.password.trim() !== '');
    }

    public async login() {
        if (this.user.username.toLowerCase() === this.userName.toLowerCase()) {
            const result = await this.logInService.login(this.userName, this.password, "");
            if (result.isSuccess && result.isOTPEnabled) {
                this.data = result.data;
                this.otpExpiresAt = result.expiresAt;
                this.countDown = result.duration;
                this.switchToOtpForm();
                this.countDownTimerOTP();
            } else if (result.isSuccess && !result.isOTPEnabled) {
                await this.tokenService.setToken(result.data);
                const expiresIn = parseInt(result.duration, 0);
                localStorage.timer = expiresIn * 60;
                localStorage.expiresIn = moment().add(expiresIn, 'minutes').format('lll');
                this.userRole = this.GetUserRole;
                if (this.userRole === 8) {
                    window.location.href = '/Providers';
                } else {
                    window.location.href = '/Dashboard';
                }
                this.loginDialog = false;
            } else {
                this.loginDialog = false;
                Toaster.error(result.errorMessage);
            }
        } else {
            this.errorUserCertificate = true;
        }
    }

    public switchToOtpForm() {
        this.logInForm = false;
        this.otpForm = true;
    }

    public countDownTimerOTP() {
        if (this.countDown > 0) {
            setTimeout(() => {
                this.countDown -= 1;
                this.countDownTimerOTP();
            }, 1000);
        }
    }

    public async resendOtp() {
        const result = await this.logInService.resendOTP(this.data);
        if (result.isSuccess) {
            this.data = result.data;
            this.otpExpiresAt = result.expiresAt;
            this.countDown = result.duration;
            this.countDownTimerOTP();
        } else {
            Toaster.error(result.errorMessage);
        }
    }

    public async verfiyOTP() {
        const result = await this.logInService.verfiyOTP(this.data, this.otpExpiresAt, this.otp);
        if (result.isSuccess) {
            await this.tokenService.setToken(result.token);
            const expiresIn = parseInt(result.expiresIn, 0);
            localStorage.timer = expiresIn * 60;
            localStorage.expiresIn = moment().add(expiresIn, 'minutes').format('lll');
            this.loginDialog = false;
            this.logInForm = true;
            this.otpForm = false;
        } else {
            this.loginDialog = false;
            this.logInForm = true;
            this.otpForm = false;
            Toaster.error(result.errorMessage);
        }
    }

    public get isResendValid(): boolean {
        return (this.countDown > 0);
    }

    private allowedScreens: Set<string> | null = null;

    private isScreenAllowedByKey(menuKey: string): boolean {
        const screen = KEY_TO_SCREEN[menuKey];
        if (!screen) return true;
        if (!this.allowedScreens) return true;
        return this.allowedScreens.has(screen);
    }

    private applyPermissions(menu: any[]): any[] {
        return menu.map(item => {
            const ownShow = item.show !== false && this.isScreenAllowedByKey(item.key);

            if (Array.isArray(item.children) && item.children.length) {
                const children = item.children
                    .map((c: any) => ({ ...c, show: (c.show !== false) && this.isScreenAllowedByKey(c.key) }))
                    .filter((c: any) => c.show);

                const hasRoute = !!item.route;
                const showParent = hasRoute ? ownShow : (children.length > 0);

                return { ...item, show: showParent, children };
            }

            return { ...item, show: ownShow };
        });
    }

    private async refreshAllowedScreens(): Promise<void> {
        if (this.GetUserRole !== 4) {
            this.allowedScreens = null;
            return;
        }
        const res = await this.permissionManagementService.GetPermissions(this.user.userId);
        const ok = res && (res.isSuccess === true || res.IsSuccess === true);
        if (!ok) return;

        const list = (res.result || res.Result || []) as Array<{ screenKey?: string; ScreenKey?: string; isAllowed?: boolean; IsAllowed?: boolean }>;
        this.allowedScreens = new Set(
            list
                .filter(x => x.isAllowed === true || (x as any).IsAllowed === true)
                .map(x => (x.screenKey || (x as any).ScreenKey) as string)
        );
    }
}
